import i18next from "i18next";

export default function getMaterialTableLocalization() {
    return {
        header: {
            actions: i18next.t("materialTable.header.actions")
        },
        toolbar: {
            searchPlaceholder: i18next.t("materialTable.toolbar.searchPlaceholder"),
            searchTooltip: i18next.t("materialTable.toolbar.searchTooltip")
        },
        pagination: {
            labelDisplayedRows: i18next.t("materialTable.pagination.labelDisplayedRows"),
            labelRowsSelect: i18next.t("materialTable.pagination.labelRowsSelect"),
            labelRowsPerPage: i18next.t("materialTable.pagination.labelRowsPerPage"),
            firstAriaLabel: i18next.t("materialTable.pagination.firstAriaLabel"),
            firstTooltip: i18next.t("materialTable.pagination.firstTooltip"),
            previousAriaLabel: i18next.t("materialTable.pagination.previousAriaLabel"),
            previousTooltip: i18next.t("materialTable.pagination.previousTooltip"),
            nextAriaLabel: i18next.t("materialTable.pagination.nextAriaLabel"),
            nextTooltip: i18next.t("materialTable.pagination.nextTooltip"),
            lastAriaLabel: i18next.t("materialTable.pagination.lastAriaLabel"),
            lastTooltip: i18next.t("materialTable.pagination.lastTooltip")
        },
        body: {
            emptyDataSourceMessage: i18next.t("materialTable.body.emptyDataSourceMessage"),
            filterRow: {
                filterTooltip: i18next.t("materialTable.body.filterRow.filterTooltip")
            },
            editTooltip: i18next.t("materialTable.body.editTooltip"),
            deleteTooltip: i18next.t("materialTable.body.deleteTooltip"),
            addTooltip: i18next.t("materialTable.body.addTooltip"),
            editRow: {
                deleteRow: i18next.t("materialTable.body.editRow.deleteRow"),
                cancelTooltip: i18next.t("materialTable.body.editRow.cancelTooltip"),
                saveTooltip: i18next.t("materialTable.body.editRow.saveTooltip")
            }
        }
    }
}